import React from "react";

import { Link } from "react-router-dom";

import type { HTMLAttributeAnchorTarget, JSX, ReactNode } from "react";

type RestProps = Record<string, unknown>;

type AbilitylinkProps<T extends RestProps> = {
  to: string;
  children: ReactNode;
  canAccess: boolean;
  target?: HTMLAttributeAnchorTarget;
} & T;

function AbilityLink<T extends RestProps>({
  to,
  children,
  canAccess,
  target,
  ...props
}: AbilitylinkProps<T>): JSX.Element {
  if (canAccess) {
    if (target) {
      return (
        <a
          href={to}
          target={target}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        >
          {children}
        </a>
      );
    }
    return (
      <Link
        to={to}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {children}
      </Link>
    );
  }

  return (
    <div
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </div>
  );
}

export default AbilityLink;
